import { USERS_STATE_NAME, UsersState } from 'projects/access-control/src/app/Infrastructure/Store/users/users.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectUserState = createFeatureSelector<UsersState>(USERS_STATE_NAME);
export const setUsers = createSelector(selectUserState, (form: UsersState) => form.users);
